import React, { ReactNode } from 'react';
import { useSiteMetadata } from './useSiteMetadata';
import { SeoInfo } from 'src/constants/seo';

interface SEOProps {
  pagePath: string;
  metaInfo?: SeoInfo;
}

export const SEO = (props: SEOProps) => {
  const { metaInfo, pagePath } = props;
  const siteDefaults = useSiteMetadata();

  const title = metaInfo?.title ?? siteDefaults.title;
  const description = metaInfo?.description ?? siteDefaults.description;
  const keywords = siteDefaults.keywords;

  // trim starting slash, if any
  const pagePathTrimmed = pagePath?.replace(/^\//, '') ?? '';

  return (
    <>
      <html lang="en" />
      <title>{title}</title>
      <meta httpEquiv="Accept-CH" content="DPR, Width, Viewport-Width" />
      <meta property="og:locale" content="en_US" />
      <meta name="google-site-verification" content="66TKUunY8W50xViBpAfYxATxp3w_aWMpC2B9LpdyKzM" />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:url" content={`https://www.catperson.com/${pagePathTrimmed ?? ''}`} />
      <meta property="og:image" content={metaInfo?.imageUrl ?? ''} />
      <meta property="og:title" content={`${title}`} />
      <meta property="og:site_name" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:site" content="@CatPerson" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${title}`} />
      <meta name="twitter:image:src" content={metaInfo?.imageUrl ?? ''} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:url" content={`https://www.catperson.com/${pagePathTrimmed ?? ''}`} />
    </>
  );
};
